import { render } from "./RoleSeat.vue?vue&type=template&id=75a79c4c&ts=true"
import script from "./RoleSeat.vue?vue&type=script&lang=ts"
export * from "./RoleSeat.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__